import React from "react";
import Checkbox from "antd/es/checkbox";
import Divider from "antd/es/divider";
import Text from "antd/es/typography/Text";
import { bookingSmallStyle } from "../../bookingStyles";

interface OptionCheckBoxProps {
  showPrice?: boolean;
  option?: {
    title: string;
    price: number;
  };
  onOpenOptionModal: () => void;
}

const OptionCheckBox = ({
  showPrice,
  option,
  onOpenOptionModal,
}: OptionCheckBoxProps) => {
  return option ? (
    <Checkbox
      checked={true}
      onChange={onOpenOptionModal}
      style={{ minHeight: 40, alignItems: "center" }}
    >
      <Text strong>Option:</Text>{" "}
      <Text style={bookingSmallStyle}>
        {option.title}
        {showPrice && typeof option.price === "number" && option.price > 0 && (
          <>
            <Divider orientation="vertical" />${option.price}
          </>
        )}
      </Text>
    </Checkbox>
  ) : (
    <Checkbox
      onChange={onOpenOptionModal}
      style={{ minHeight: 40, alignItems: "center" }}
    >
      <Text style={bookingSmallStyle}>
        Do you need more specific options?
      </Text>
    </Checkbox>
  );
};

export default OptionCheckBox;
